import { render, staticRenderFns } from "./PdoBanner.vue?vue&type=template&id=f526c624"
import script from "./PdoBanner.vue?vue&type=script&lang=js"
export * from "./PdoBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports